<template>
  <div class="page">
    <button @click="userLogin">点击登录系统</button>
  </div>
</template>

<style scoped>
.page {
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

button {
  width: 100px;
  height: 32px;
}
</style>

<script>
import { mapMutations } from 'vuex';

export default {
  beforeMount() {
    if (this.$route.query.token) {
      this.login(this.$route.query.token);
      this.$router.push({ name: 'home' });
    }
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {
    ...mapMutations(['login']),
    userLogin() {
      this.$api.index
        .analytics(1, 'going').then(res => {
          console.log(res);
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index/index.vue